import React from 'react'
import { Table } from 'react-bootstrap'

const MapTable = ({ resourceGroups, resourceGroupIndex, clickTableRow, clearOneMapping, selectMapping, children, step, mode, showApiNames }) => {

  var childs;
  if(React.Children.count(children) > 0){
    childs = React.Children.toArray(children)
  } else {
    return <div/>
  }

  const isReverse = mode==='reverse'

  const normalGroup = resourceGroups
    .filter(g=>step.destinationProvider.toLowerCase()===g.provider.toLowerCase())
  const reverseGroup = resourceGroups
    .filter(g=>step.sourceProvider.toLowerCase()===g.provider.toLowerCase())
   
  const groups = isReverse ? reverseGroup : normalGroup

  const srcLabel = step.sourceConfig.label || step.sourceProvider
  const destLabel = step.destinationConfig.label || step.destinationProvider

  const title = isReverse ?
      `${destLabel} to ${srcLabel} Field Mappings` :
      `${srcLabel} to ${destLabel} Field Mappings`

  if(isReverse && !(reverseGroup && reverseGroup.length>0)) return <div/>

  const clearMapping = (i,mapping) => clearOneMapping(i,mapping)

  return(
    <div>
      <br/>
      <div style={{fontSize:'16px'}}>{title}</div>
      <Table condensed hover>
        <thead className="mapping-table-header">
          <tr>
            <th>Source</th>
            <th>Mapping</th>
            <th>Transform</th>
            <th>Target</th>
          </tr>
        </thead>
        <tbody>
          {groups && groups.filter(g => g.resources).map((group, i)=>
            <tr key={i} onClick={()=>clickTableRow(i)}
              style={{background: i===resourceGroupIndex ? '#f4f6f9' : 'white', cursor:'pointer'}}>
              <td style={{paddingLeft:14, whiteSpace:'nowrap',color: 'rgb(22, 50, 92)'}}>
                {React.Children.count(children) > 0 ?
                    React.cloneElement(
                      childs[0], { group, step, isReverse, showApiNames }
                    )
                : null}
              </td>
              <td style={{color: 'rgb(22, 50, 92)'}}>
                {React.Children.count(children) > 1 ?
                    React.cloneElement(
                      childs[1], { group, i, clearMapping, showApiNames }
                    )
                : null}
              </td>
              <td style={{color: 'rgb(22, 50, 92)'}}>
                {React.Children.count(children) > 2 ?
                    React.cloneElement(
                      childs[2], { group, i, selectMapping, showApiNames }
                    )
                : null}
              </td>
              <td style={{verticalAlign:'middle', paddingRight:10,color: 'rgb(22, 50, 92)'}}>
                {React.Children.count(children) > 3 ?
                    React.cloneElement(
                      childs[3], { group, step, isReverse, showApiNames }
                    )
                : null}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  )
}

export default MapTable


// WEBPACK FOOTER //
// ./src/lib/themes/lingk/MapTable.js